import type {
  PersistOptions,
  ProviderConfig,
  TerminalConfig,
} from "../types";

export const TERMINAL_DEFAULTS = {
  panelHeight: 420,
  maxHistory: 200,
  placeholder: "Ask anything, or type /help…",
  title: "AI Terminal",
  hotkey: "ctrl+`" as string | null,
  defaultOpen: false,
};

const PERSIST_DEFAULTS: Required<PersistOptions> = {
  namespace: "@aerelontech/react-terminal",
  persistHistory: true,
  persistApiKeys: false,
};

/** Resolves the persist config into concrete options, or null when disabled. */
export function resolvePersist(
  persist: TerminalConfig["persist"],
): Required<PersistOptions> | null {
  if (persist === false) return null;
  if (persist === undefined || persist === true) return { ...PERSIST_DEFAULTS };
  return { ...PERSIST_DEFAULTS, ...persist };
}

/** Picks the active provider given the config + a possibly-persisted id. */
export function resolveActiveProvider(
  providers: ProviderConfig[],
  activeId: string | undefined,
): ProviderConfig | undefined {
  if (!providers.length) return undefined;
  return providers.find((p) => p.id === activeId) ?? providers[0];
}

/** The system prompt for a provider: its own overrides the global one. */
export function resolveSystemPrompt(
  config: TerminalConfig,
  provider: ProviderConfig | undefined,
): string | undefined {
  return provider?.systemPrompt ?? config.systemPrompt;
}
